import React from "react";

export default React.memo(function SpotifyPlayer({ url }) {
  // Extrae el ID y tipo de la URL de Spotify
  let embedUrl = "";
  try {
    const match = url.match(
      /spotify\.(com)\/(track|album|playlist|artist)\/([a-zA-Z0-9]+)/,
    );
    if (match) {
      embedUrl = `https://open.spotify.com/embed/${match[2]}/${match[3]}`;
    }
  } catch {}
  if (!embedUrl) return null;
  return (
    <div
      className="spotify-player"
      style={{
        position: "fixed",
        width: "min(440px, 100vw - 40px)",
        height: 152,
        bottom: 20,
        right: 20,
        zIndex: 1000,
        borderRadius: 12,
        overflow: "hidden",
        opacity: 0.9,
      }}
    >
      <iframe
        src={embedUrl}
        width="100%"
        height="152"
        frameBorder="0"
        allowtransparency="true"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        allowFullScreen
        loading="lazy"
        title="Spotify Player"
        style={{ borderRadius: 8, display: "block" }}
      />
    </div>
  );
});
